






































































































































































































import { ItemDaVenda, Cliente, Venda } from '@/models'
import { Vue, Component, Ref } from 'vue-property-decorator'
import { formatarCnpjOuCpf, formatarMoeda } from '@/shareds/formatadores'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import CampoDeItemDeVenda from '@/components/venda/CampoDeItemDeVenda.vue'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import { converterProdutoParaProdutoSimples } from '@/shareds/produto-shareds'
import {  FindModalidadeDeVendaUseCase, FindProdutoUseCase, FindVendaUseCase } from '@/usecases'
import VueQuagga from "vue-quaggajs"
import { obrigatorio } from '@/shareds/regras-de-form'
import { ItemDeRomaneio } from '@/models/Romaneio'
import CampoDeClienteNoCaixa from './CampoDeClienteNoCaixa.vue'
import AplicarTabelaDePrecoUseCase from '@/usecases/tabela-de-precos/AplicarTabelaDePrecoUseCase'
import { obterTotalDoItem, obterTotalDoItemSemDesconto, obterValorDoItemDevolucao } from '@/shareds/venda-shareds'
import Confirmacao from '@/components/ui/Confirmacao.vue'

Vue.use(VueQuagga);


@Component({
	components:{
		CampoDeItemDeVenda,
		CampoDeClienteNoCaixa,
		Confirmacao,
	},
})
export default class DialogoDeIdentificacaoDaTroca extends Vue {
	@Ref() readonly campoDeBusca!: CampoDeItemDeVenda
	@Ref() confirmaVendedorTroca!: Confirmacao
	@Ref() seletorClientePresente!: Confirmacao
	
	obrigatorio = obrigatorio
	formatarMoeda = formatarMoeda
	obterTotalDoItem = obterTotalDoItem
	obterTotalDoItemSemDesconto = obterTotalDoItemSemDesconto

	clienteDoPresente: 'Comprador' | 'Presenteado' | undefined = undefined
	isVendaOriginalPresente = false
	itensBipados: ItemDeRomaneio[] = []
	findProdutoUseCase = new FindProdutoUseCase()
	findVendaUseCase = new FindVendaUseCase()
	findModalidadeDeVendaUseCase = new FindModalidadeDeVendaUseCase()
	buscandoCliente = false

	valorLido: string | null = null
	loading = false
	mostrarDialogoLeituraDeCodigoBarras = false
	showCamera = false
	buscandoProduto = false
	mostraConsultaDeProduto = false
	carregandoCardDeVerificacao = false
	mostra = false

	cpfOuCnpjDoClienteDoDialogo = this.cpfOuCnpjDoCliente

	set venda(venda: Venda) {
		VendaModule.setVendaAtual(venda)
	}

	get venda() {
		return VendaModule.vendaAtual as Venda
	}

	get lojaDaVenda() {
		return VendaModule.lojaDaVenda
	}

	get cpfOuCnpjDoCliente(): string {
		return VendaModule.vendaAtual && (VendaModule.vendaAtual.cpfDoCliente)
			? formatarCnpjOuCpf(VendaModule.vendaAtual.cpfDoCliente)
			: 
			VendaModule.vendaAtual && VendaModule.vendaAtual.cliente
				? formatarCnpjOuCpf(VendaModule.vendaAtual.cliente.cnpjOuCpf)
				:
				''
	}
	
	set cpfOuCnpjDoCliente(cpf: string) {
		if (!VendaModule.vendaAtual) return

		VendaModule.vendaAtual.cpfDoCliente = cpf
	}

	mostrar(){
		this.mostra = true
	}

	readerSize = {
		width: 860,
		height: 480,
	}

	async logIt(data: any) {
		this.showCamera = false
		this.buscandoProduto = true
		this.beep()
		this.valorLido = data.codeResult.code

		if (this.valorLido && this.lojaDaVenda) {
			try {
				const produto = await this.findProdutoUseCase.findProdutoComEstoque(
					this.valorLido,
					this.lojaDaVenda.id,
				)

				const item: ItemDaVenda = {
					id: '',
					produto: converterProdutoParaProdutoSimples(produto),
					quantidade: 0,
					quantidadeLida: 0,
					desconto: { isPercentual: true, valor: 0.0 },
					preco: produto.preco || 0,
					precoDeCusto: 0,
					idConjunto: null,
					descontoVarejo: 0,
					percentualCashback: 0,
					diasParaEfetivarCashback: 0,
					isBrinde: false,
					idItemNotaOrigem: null,
					chaveNotaOrigem: null,
					diasParaExpirarCashback: 0,
					possuiDescontoPorTabela: false,
					valorDescontoRateadoDoItem: 0,
					itemDeDevolucao: false,
					isTotalmenteTrocado: false,
					motivoCancelamento: null,
					isCompra: false,
					idItemOrigem: '',
					isDaVendaReaberta: false,
					vendedor: null,
					autenticadoParaLiberarProdutoSemEstoque: false,
					vendaOrigemDoItem: null,
					valorFreteRateado: 0,
					isItemReferenteATroca: false,
					isDeOutraLoja: false,
					percentualDescontoTabelaPreco: 0,
					precoDeCustoReal: 0,
					skuPai: produto.tipo === 'Variante' ? produto.skuPai : produto.sku,
				}

				this.incluirItensNaTabela(item)
			} catch (error: any) {
				AlertModule.setError(error)
			} finally {
				this.buscandoProduto = false
				this.showCamera = true
			}
		}
	}

	async incluirItensNaTabela(item: ItemDaVenda) {
		this.loading = true
		setTimeout(() => {
			this.campoDeBusca.blur()
		})

		if (!this.venda || !this.lojaDaVenda) {
			AlertModule.setError('Selecione uma loja ou venda!')
			this.loading = false
			return
		}

		try {
			
			const vendaOrigemDoItem = await this.findVendaUseCase.buscarOrigem(item.produto.id, 1, this.lojaDaVenda.id, VendaModule.vendaAtual?.cpfDoCliente || '', this.venda.itens)

			if (vendaOrigemDoItem?.isDeOutraLoja) {
				this.venda.tipoDeTransacao = 'Outros'
			}

			if (vendaOrigemDoItem?.isPresente) {
				this.isVendaOriginalPresente = true
			}

			const indiceDoItemBipado = this.venda.itens.findIndex(itemVenda =>
				itemVenda.produto.sku === item.produto.sku &&
				itemVenda.vendaOrigemDoItem === (vendaOrigemDoItem?.vendaOrigemDoItem ?? null) &&
				itemVenda.idItemOrigem === (vendaOrigemDoItem?.id ?? ''))
			
			try {
				const itensComPrecoAplicado = await AplicarTabelaDePrecoUseCase({
					loja: this.lojaDaVenda,
					itens: [item],
					tipoDeCliente: this.venda.tipoDeCliente,
					validarLimiteDeProduto: true,
					vendaAtual: this.venda,
				})

				if (indiceDoItemBipado === -1) {
					itensComPrecoAplicado.forEach(itemComPrecoAplicado => {
						itemComPrecoAplicado.vendaOrigemDoItem = vendaOrigemDoItem?.vendaOrigemDoItem ?? null
						itemComPrecoAplicado.idItemOrigem = vendaOrigemDoItem?.id ?? ''
						itemComPrecoAplicado.notaNaoEletronica = vendaOrigemDoItem ? vendaOrigemDoItem.notaNaoEletronica : false
						
						if (vendaOrigemDoItem) {
							itemComPrecoAplicado.preco = obterValorDoItemDevolucao(vendaOrigemDoItem, vendaOrigemDoItem.quantidade)
							itemComPrecoAplicado.vendedor = vendaOrigemDoItem.vendedor
							itemComPrecoAplicado.percentualCashback = vendaOrigemDoItem.percentualCashback
							itemComPrecoAplicado.desconto = {
								isPercentual: false,
								valor: 0,
							}
							itemComPrecoAplicado.isDeOutraLoja = vendaOrigemDoItem.isDeOutraLoja
						}

						this.venda.itens.push(itemComPrecoAplicado)
					})
				} else {
					this.venda.itens[indiceDoItemBipado].quantidade = this.venda.itens[indiceDoItemBipado].quantidade + item.quantidade
				}
			} catch (error: any) {
				AlertModule.setError(error)
				return
			}
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.loading = false
			setTimeout(() => {
				this.campoDeBusca.focus()
			})
		}
	}

	beep() {
		const audio = document.querySelector('audio')
		if(!audio) return 
		audio.play()
	}

	fecharDialogo(){
		this.mostra = false
		this.mostraConsultaDeProduto = false
		this.cancelar()
	}

	atualizarCliente(cliente: Cliente) {
		this.cpfOuCnpjDoCliente = formatarCnpjOuCpf(cliente.cnpjOuCpf)
		this.cpfOuCnpjDoClienteDoDialogo = this.cpfOuCnpjDoCliente
	}

	cancelar() {
		this.venda.itens = []
		this.venda.cliente = null
		this.venda.cpfDoCliente = null
		this.clienteDoPresente = undefined
		this.isVendaOriginalPresente = false
		this.mostra = false
	}

	async iniciarTroca() {
		const params = {
			isDevolucao:true,
			isDemonstracao:false,
			isVenda:false,
		}
		if (this.venda.pontoDeVenda) {
			this.venda.modalidadeDeVenda = await this.findModalidadeDeVendaUseCase.findModalidadePadrao(this.venda.pontoDeVenda.loja.id, params)
		}

		const vendasOrigemDiferentes = [] as string[]

		this.venda.itens.forEach(item => {
			if (!item.vendaOrigemDoItem) return
			
			if (vendasOrigemDiferentes.filter(vendaOrigem => vendaOrigem === item.vendaOrigemDoItem).length === 0) {
				vendasOrigemDiferentes.push(item.vendaOrigemDoItem)
			}
		})

		const possuiOrigem = this.venda.itens.filter(item => !!item.vendaOrigemDoItem).length > 0
		const origemDeOutraLoja = this.venda.itens.filter(item => item.isDeOutraLoja).length === 0
		const possuiOrigensDiferentes = vendasOrigemDiferentes.length > 1

		this.venda.tipoDeTransacao = possuiOrigem && origemDeOutraLoja && !possuiOrigensDiferentes ? 'Devolução' : 'Outros'

		if (this.clienteDoPresente === 'Presenteado') {
			this.venda.tipoDeTransacao = 'Outros'
		}

		if (this.venda.itens.filter(item => item.isDeOutraLoja).length > 0) {
			this.venda.isOperacaoPresencial = true
		}

		this.venda.tipoNota = 'Entrada'
		this.venda.itens.forEach(item => item.quantidade = -Math.abs(item.quantidade))
		this.clienteDoPresente = undefined
		this.isVendaOriginalPresente = false
		this.mostra = false
		this.$emit('iniciarTroca')
	}

	abrirDialogoDeConfirmacao(){
		if (this.isVendaOriginalPresente && this.clienteDoPresente === undefined) {
			this.seletorClientePresente.mostrar()
			return
		}
		this.prosseguirComTroca()
	}

	confirmarTipoClientePresente(opcao: string) {
		this.clienteDoPresente = opcao as 'Comprador' | 'Presenteado'
		this.prosseguirComTroca()
	}

	prosseguirComTroca() {
		if (this.lojaDaVenda?.configuracaoDaLoja.bloqueiaMultiplosVendedoresNaTroca) {
			this.iniciarTroca()
			return
		}
		const mensagemComVendedores = `Vendedores: ${this.nomesDosVendedores()}.`
		this.confirmaVendedorTroca.subtitulo = mensagemComVendedores
		this.confirmaVendedorTroca.mostrar()
	}

	zerarVendedores(){
		if(!this.venda) return

		this.venda.itens.forEach(item => item.vendedor = null)
		this.venda.vendedor = null
		this.iniciarTroca()
	}

	nomesDosVendedores() {
		if(!this.venda) return
		const vendedores = new Set();
		this.venda.itens.forEach(item => {
			if (item.vendedor && item.vendedor.nome) {
				vendedores.add(item.vendedor.nome);
			}
			else{
				vendedores.add("Sem vendedor");
			}
		});
		return Array.from(vendedores).join(", ");
	}
}

